<template>
  <div class="m-person-card">
    <Transition name="fade">
      <div v-if="!loading">
        <div class="m-person-card__header-container">
          <div
              class="m-person-card__initials"
              data-test="m-person-card-initials">
            <div class="m-person-card__initials__text">{{ name | initials }}</div>
          </div>
          <div class="m-person-card__name">
            {{ name }}
          </div>
        </div>

        <div class="m-person-card__email">
          {{ email }}
        </div>
        <slot name="extra-content" class="m-person-card__extra-content" />
      </div>
      <div  class="placeholder" v-else>
        <div class="placeholder-image"></div>
        <div class="placeholder-title"></div>
        <div class="placeholder-name"></div>
        <div class="placeholder-email"></div>
        <div class="placeholder-buttons"></div>
        <div class="placeholder-buttons"></div>
      </div>
    </Transition>
  </div>
</template>

<script>
import initialsFilter from '@/filters/InitialsFilter';

export default {
  name: 'VPersonCard',
  props: {
    name: {
      type: [String],
      required: true,
    },
    email: {
      type: [String],
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  filters: {
    initials: initialsFilter,
  },
};
</script>

<style scoped>
.m-person-card {
  position: relative;
  padding: var(--spacing-base);
  border: 1px solid var(--color-border);
  border-radius: 9px;
  height: 100%;
  width: 100%;
  cursor: pointer;
  box-shadow: 0px 0px 5px -2px var(--color-border);
  transition: border .15s ease-in-out, background .15s ease-in-out, box-shadow .15s ease-in-out, opacity 0.5s ease, max-height .5s ease, min-height .5s ease, transform .15s ease;
}

.m-person-card:after {
  content: '';
  display: block;
  clear: both;
}

.m-person-card:hover {
  box-shadow: 0px 0px 5px 0px var(--color-border);
}

.m-person-card__header-container {
  display: flex;
  align-items: center;
}

.m-person-card__extra-content {
  margin-top: var(--spacing-xs);
  display: flex;
  justify-content: flex-start;
}

.m-person-card__extra-content--content {
  margin-right: var(--spacing-xs);
}

.m-person-card__initials {
  position: relative;
  display: inline-block;
  background: var(--signable-secondary-2);
  width: 28px;
  height: 28px;
  color: #fff;
  border-radius: 14px;
  font-size: 14px;
  font-weight: bold;
}

.m-person-card__initials__text {
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.m-person-card__name {
  display: inline-block;
  font-family: 'Roboto Slab', serif;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-large);
  margin-left: var(--spacing-small);
  max-width: calc(100% - 40px);
}

.m-person-card__email {
  overflow: hidden;
  text-transform: lowercase;
  color: var(--signable-secondary-3);
  text-overflow: ellipsis;
  margin: var(--spacing-xs) 0 var(--spacing-xs) 0;
  font-size: var(--font-size-medium);
  line-height: var(--font-size-large);
}

.placeholder {
  animation: pulse 2s ease-in-out infinite;
}

.placeholder-image {
  margin-bottom: var(--spacing-xs);
  display: inline-block;
  background: var(--color-border);
  border-radius: 15px;
  width: 30px;
  height: 30px;
}

.placeholder-title {
  margin-bottom: var(--spacing-xs);
  margin-left: var(--spacing-base);
  display: inline-block;
  background: var(--color-border);
  border-radius: 4px;
  width: 70%;
  height: 30px;
}

.placeholder-name {
  margin-top: var(--spacing-xs);
  background: var(--color-border);
  border-radius: 4px;
  width: 60%;
  height: 20px;
}

.placeholder-email {
  margin-top: var(--spacing-xs);
  background: var(--color-border);
  border-radius: 4px;
  width: 75%;
  height: 20px;
}

.placeholder-buttons {
  margin-top: var(--spacing-xs);
  margin-right: var(--spacing-base);
  display: inline-block;
  background: var(--color-border);
  border-radius: 4px;
  width: 15%;
  height: 20px;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
